export default __webpack_public_path__ + "static/about-me-min-74f040f20eea13eeb62186a0ee3be0a7.png";